import React, { useEffect } from 'react';
import System from 'src/helper/system';
import HCLDX from "@system/config/hcldx";
import Profile from '@system/config/profile';
import Constants from 'src/helper/Constants';
import { profileStore } from 'src/hooks/profile';
import Helper from 'src/helper/Helper';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import RoleAndPermission from 'src/helper/RoleAndPermission';

const ProfileInformation = () => {
    const { siteUser: { WEB, CORE }, speedBoats: { apacAbbr } } = Constants
    const { avUserInfoData: { currentUser, accountNumber, accountName }, storageName: { ACCOUNT_LINK_SUCCESS_MESSAGE } } = System
    const isCoreUSer = currentUser === CORE
    const { translation: t } = System;
    const [{ profile_user_information }, { get_profile_account_information }] = profileStore();
    const [__check] = useAxiosIndicatorCheck();
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
    const [{ }, { clear_all_system_alert }, { }] = useDOMAttachToSystemStore();

    const isRequestToJoinAccountPermission = RoleAndPermission.checkActivePermission(RoleAndPermission.profilePermission.req_to_join_existing_acc)

    const OpenContactInfoPopup = (name) => {
        clear_all_system_alert()
        sessionStorage.removeItem(ACCOUNT_LINK_SUCCESS_MESSAGE)
        System.popup('ContactInformationPopup', { msg: name });
    }

    const existingAccountRedirection = () => {
        window.location.href = Profile.getLinkToExistingAccountURL();
    }

    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }
        if (profile_user_information && Object.keys(profile_user_information).length <= 0) {
            fetchHere()
        }
    }, [profile_user_information])

    return (
        <>{__check("PROFILE_ACCOUNT_INFORMATION").status ? __check('PROFILE_ACCOUNT_INFORMATION').render :
            <div>
                <div className=''>
                    <div className='profile-info-container'>
                        <div className='profile-edit-profile'>
                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    {(currentUser === WEB && !System.validateDomain(System.avUserInfoData.email)) &&
                                        <a onClick={() => OpenContactInfoPopup("contactInformation")}><i className="fa fa-pencil" /> {t('editProfile')}</a>}
                                </div>
                                <div className='col-md-6'>
                                    <div className='edit-profile-list'>
                                        <ul className='m-0 p-0'>
                                            <li>
                                                <span>{t('name')}:</span>
                                                <div>{profile_user_information?.firstName}&nbsp;{profile_user_information?.lastName}</div>
                                            </li>
                                            <li>
                                                <span>{t('company')}:</span>
                                                <div>{Helper.valueIsNotNull(profile_user_information?.company) ? profile_user_information?.company : ""}</div>
                                            </li>
                                            <li>
                                                <span>{t('jobTitle')}:</span>
                                                <div>{profile_user_information?.jobTital}</div>
                                            </li>
                                            <li>
                                                <span>{t('jobFunction')}:</span>
                                                <div>{profile_user_information?.jobFunction}</div>
                                            </li>
                                            <li>
                                                <span>{t('phone')}:</span>
                                                <div>{profile_user_information?.mobileNumber}</div>
                                            </li>
                                            <li>
                                                <span>{t('email')}:</span>
                                                <div>{profile_user_information?.emailAddress}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    {isCoreUSer && <div className='mb-3'><span className='font-16 font-arial d-block '><b> {t('account')} </b></span>
                                        {currentUser === CORE && <div>{accountNumber} - {accountName}</div>}
                                        {System.getCurrentRegionWithType(apacAbbr, CORE) && isRequestToJoinAccountPermission && <a className='font-13 font-arial' onClick={existingAccountRedirection}>{t('requestToJoinExistingTermsAccount')}</a>}</div>}
                                    {!isInternalUser && <div><span className='font-16 font-arial d-block '><b> {t('password')} </b></span><a href={HCLDX.baseURL() + '/authenticate/change-password'}>{t('changePassword')}</a></div>}
                                </div>
                            </div>
                        </div>
                        <div className='profile-need-info'>
                            <div>
                                <div className='mb-4'><span className='font-16 font-arial d-block'><b> {t('needMoreInformation')} </b></span>{t('visitOur')} <a href={System.getHelpPageURL()}>{t('helpPage')}.</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    )
}
export default ProfileInformation;